/**
 * Badge when lead joined a published shared load (PWA upcoming trips)
 */

import React, { useEffect, useState } from "react";
import { Chip, Tooltip, Typography, Box } from "@mui/material";
import { LocalShipping } from "@mui/icons-material";
import { fetchPublishedTripById } from "../../publishedTrips/services/publishedTripsService.js";

const SharedLoadLeadBadge = ({ publishedTripId }) => {
  const [trip, setTrip] = useState(null);

  useEffect(() => {
    if (!publishedTripId) return;
    let cancelled = false;
    (async () => {
      const data = await fetchPublishedTripById(publishedTripId);
      if (!cancelled) setTrip(data);
    })();
    return () => {
      cancelled = true;
    };
  }, [publishedTripId]);

  if (!publishedTripId) return null;

  const label = trip?.fromLabel && trip?.toLabel
    ? `Shared load: ${trip.fromLabel} → ${trip.toLabel}`
    : `Shared load (${publishedTripId})`;

  return (
    <Tooltip
      title={
        trip?.departureWindowText
          ? `${label} · ${trip.departureWindowText}`
          : label
      }
    >
      <Chip
        icon={<LocalShipping />}
        label={label}
        size="small"
        color="primary"
        variant="outlined"
      />
    </Tooltip>
  );
};

export const SharedLoadLeadDetail = ({ publishedTripId }) => {
  const [trip, setTrip] = useState(null);

  useEffect(() => {
    if (!publishedTripId) return;
    let cancelled = false;
    (async () => {
      const data = await fetchPublishedTripById(publishedTripId);
      if (!cancelled) setTrip(data);
    })();
    return () => {
      cancelled = true;
    };
  }, [publishedTripId]);

  if (!publishedTripId) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Shared load
      </Typography>
      <SharedLoadLeadBadge publishedTripId={publishedTripId} />
      {trip?.departureWindowText && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {trip.departureWindowText}
        </Typography>
      )}
    </Box>
  );
};

export default SharedLoadLeadBadge;
